/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

const dematChargesBDSA = [
  ["Value of Holdings in the Demat Account", "Charges"],
  [
    "<span><small> a) Up to ₹ 4Lakhs</small></span>",
    "<span><small>NIL</small></span>"
  ],
  [
    "<span><small> b) More than ₹ 4 lakhs but up to ₹ 10 lakhs </small> </span>",
    "<span><small> ₹ 100 + GST </small> </span>"
  ],
  [
    "<span><small> c) More than ₹ 10 lakhs </small> </span>",
    "<span><small> ₹ 300 + GST </small> </span>"
  ]
];

export default dematChargesBDSA;
